import React, { useState, useEffect, useCallback } from 'react';
import Button from '../../../../../../component/ui/Button';
import arrowForwardIcon from '../../../../../../assets/image/arrow-forward-icon.svg';
import NewCardModal from '../componets/newCardModal';
import SubscriptionBankCard from '../componets/subscriptionBankCard';
import ManageBillingTable from '../componets/manageBillingTable';
import { axiosInstanceV2 } from '../../../../../../services/axios';
import { toast } from 'react-toastify';

const loadRazorpay = () => {
	return new Promise((resolve) => {
		if (window.Razorpay) return resolve(true);
		const script = document.createElement('script');
		script.src = 'https://checkout.razorpay.com/v1/checkout.js';
		script.onload = () => resolve(true);
		script.onerror = () => resolve(false);
		document.body.appendChild(script);
	});
};

export default function ManageBilling({ setSubscriptionScreenType }) {
	const [isOpenCardModal, setIsOpenCardModal] = useState(false);
	const [cardsList, setCardsList] = useState([]);
	const [cardsLoading, setCardsLoading] = useState(false);
	const [addingCard, setAddingCard] = useState(false);

	const fetchCards = useCallback(async () => {
		try {
			setCardsLoading(true);
			const token = localStorage.getItem('authToken');
			const response = await axiosInstanceV2.get('/razorpay/cards', {
				headers: { Authorization: `Bearer ${token}` },
			});
			setCardsList(response.data.data ?? []);
		} catch (error) {
			console.error('Failed to fetch cards:', error);
			toast.error('Failed to load saved cards');
		} finally {
			setCardsLoading(false);
		}
	}, []);

	useEffect(() => {
		fetchCards();
	}, [fetchCards]);

	const handleDeleteCard = async (token_id) => {
		try {
			const token = localStorage.getItem('authToken');
			await axiosInstanceV2.delete(`/razorpay/cards/${token_id}`, {
				headers: { Authorization: `Bearer ${token}` },
			});
			toast.success('Card removed successfully');
			fetchCards();
		} catch (error) {
			console.error('Failed to delete card:', error);
			toast.error('Failed to remove card');
		}
	};

	const handleAddCard = async () => {
		try {
			setAddingCard(true);

			const token = localStorage.getItem('authToken');
			const response = await axiosInstanceV2.get('/razorpay/customer-details', {
				headers: { Authorization: `Bearer ${token}` },
			});

			const { razorpay_customer_id, razorpay_key_id } = response.data.data;

			if (!razorpay_customer_id) {
				toast.error('No Razorpay customer found. Please complete subscription first.');
				return;
			}

			const loaded = await loadRazorpay();
			if (!loaded) {
				toast.error('Razorpay SDK failed to load');
				return;
			}

			const options = {
				key: razorpay_key_id,
				customer_id: razorpay_customer_id,
				recurring: 1,
				name: 'Pharmnex',
				description: 'Save payment method',
				currency: 'INR',
				amount: 0,

				handler: async (response) => {
					toast.success('Card saved successfully');
					setAddingCard(false);
					fetchCards();
				},

				modal: {
					ondismiss: () => {
						setAddingCard(false);
						toast.info('Card addition cancelled');
					},
				},

				prefill: {
					contact: response.data.data?.contact ?? '',
					email: response.data.data?.email ?? '',
				},

				theme: { color: '#3B58FF' },
			};

			const rzp = new window.Razorpay(options);
			rzp.open();
		} catch (error) {
			console.error('Add card error:', error);
			toast.error('Failed to initiate card addition');
			setAddingCard(false);
		}
	};

	return (
		<div>
			<div style={{ backgroundColor: '#EDEDF7', position: 'sticky', top: 0, zIndex: 99 }}>
				<div className="d-flex py-3 px-2 justify-content-between align-items-center">
					<div className="d-flex justify-content-start align-items-center gap-3">
						<div
							className="fs-4 fw-semibold cursor-pointer"
							onClick={() => setSubscriptionScreenType('subscription')}
						>
							My Subscription
						</div>
						<img
							width={12}
							height={12}
							src={arrowForwardIcon}
							alt="arrow-icon"
						/>
						<div className="fs-4 fw-semibold">Manage Billing</div>
					</div>
					<div className="d-flex px-3">
						<Button
							type="button"
							className="mt-0 btn-danger fs-5 fw-light add-pro py-1"
							button=""
							close
							onClick={() => setSubscriptionScreenType('subscription')}
						/>
					</div>
				</div>
			</div>

			<div
				className="px-3 pt-3 pb-2"
				style={{ overflow: 'hidden' }}
			>
				<div className="d-flex align-items-center gap-5">
					<div className="fs-4 fw-bold py-2">Payment Method</div>
					<div
						style={{
							color: addingCard ? 'gray' : 'blue',
							cursor: addingCard ? 'not-allowed' : 'pointer',
							textDecorationLine: 'underline',
						}}
						onClick={!addingCard ? handleAddCard : undefined}
					>
						{addingCard ? 'Opening...' : '+ Add New'}
					</div>
				</div>

				<div className="row">
					{cardsLoading ? (
						<div className="py-3 px-2 text-muted">Loading cards...</div>
					) : cardsList.length === 0 ? (
						<div className="py-3 px-2 text-muted fs-5">
							No saved cards. Click "+ Add New" to add one.
						</div>
					) : (
						cardsList.map((card) => (
							<SubscriptionBankCard
								key={card.token_id}
								card={card}
								onDelete={() => handleDeleteCard(card.token_id)}
							/>
						))
					)}
				</div>

				<ManageBillingTable />
			</div>

			{isOpenCardModal && (
				<NewCardModal
					isOpenModal={isOpenCardModal}
					setIsOpenModal={setIsOpenCardModal}
				/>
			)}
		</div>
	);
}
